/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
// import * as userService from '../../../services/userService'
import { BASE_IMAGE_PATH } from '../../configs/api';
class MPModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         passcode: "",
         repasscode: "",
         mpassword: "",
         toastMsg: "",
         toastType: ""
      };
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   handleKey(e) {
      if (e.keyCode === 13) {
         this.props.setMasterPassword(this.state.mpassword)
      }
    }
   render() {
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="mywithdraw" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">Master Password</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop ">
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>Master Password</label>
                           </div>
                           <div className="col-md-8">
                              <input type="Password" autoFocus tabIndex={1} onKeyUp={(e) => { this.handleKey(e) }} name="mpassword" value={this.state.mpassword} onChange={(e) => { this.onChange(e) }} id="mpassword" required="" />
                           </div>
                        </div>
                     </div>
                     <div className="modal-footer">
                        <a  onDoubleClickCapture={(e)=>{e.preventDefault();return false;}} onClick={() => { if (!this.state.loading) { this.props.setMasterPassword(this.state.mpassword) } }} tabIndex={4} style={{ cursor: "pointer" }} className="pop-edit-btn">Submit {this.state.loading && <img style={{ height: "16px" }} alt="" src={BASE_IMAGE_PATH + "/aimg/loader.gif"} />}</a>
                        &nbsp;&nbsp;
                        {/* <a className="pop-edit-btn" tabIndex={5} style={{ cursor: "pointer" }} onClick={() => { this.props.closePopup() }} data-dismiss="modal">Cancel</a> */}
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
               </div>            
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(MPModel);